module.exports = __webpack_public_path__ + "static/02_mobile-cc79f1003cad36a1f9a1af2d9554dc64.png";